const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

const getLocalStorage = () => {
  if (typeof window !== "undefined") {
    return window.localStorage;
  }
  return null;
};

export const registerUser = async (userData) => {
  const response = await fetch(`${API_BASE_URL}/api/user/auth/register`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(userData),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Registration failed");
  }

  return await response.json();
};

export const verifyUserOTP = async ({ email, otp }) => {
  const response = await fetch(`${API_BASE_URL}/api/user/auth/verify-otp`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, otp }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "OTP verification failed");
  }

  return await response.json();
};

export const loginUser = async ({ email, password }) => {
  const response = await fetch(`${API_BASE_URL}/api/user/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Login failed");
  }

  const data = await response.json();
  return data;
};

export const logoutUser = () => {
  const ls = getLocalStorage();
  if (ls) {
    ls.removeItem("userAccessToken");
    ls.removeItem("userProfile");
  }
};

export const getUserProfile = () => {
  const ls = getLocalStorage();
  if (!ls) return null;

  const profile = ls.getItem("userProfile");
  return profile ? JSON.parse(profile) : null;
};

export const isUserAuthenticated = () => {
  const ls = getLocalStorage();
  if (!ls) return false;

  return !!ls.getItem("userAccessToken");
};

export const sendOTP = async (email) => {
  const response = await fetch(`${API_BASE_URL}/api/user/auth/send-otp`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to send OTP");
  }

  return await response.json();
};

export const verifyOTP = async ({ email, otp }) => {
  const response = await fetch(`${API_BASE_URL}/api/user/auth/verify-otp`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, otp }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "OTP verification failed");
  }

  return await response.json();
};

export const getUserInitials = () => {
  const profile = getUserProfile();
  if (!profile || !profile.name) return null;

  const names = profile.name.split(" ");
  let initials = names[0].charAt(0).toUpperCase();
  if (names.length > 1) {
    initials += names[names.length - 1].charAt(0).toUpperCase();
  }
  return initials;
};

export const loginWithGoogle = async (idToken) => {
  const response = await fetch(`${API_BASE_URL}/api/user/auth/google-auth`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ idToken }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Google login failed");
  }

  return await response.json();
};